"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BlockSubtitle = _interopRequireDefault(require("./BlockSubtitle.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var BlockSubtitle = function BlockSubtitle(_ref) {
  var children = _ref.children,
    id = _ref.id,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_BlockSubtitle["default"], {
    id: id,
    className: className
  }, children);
};
BlockSubtitle.defaultProps = {
  id: 'blockSubtitle',
  className: 'block-subtitle'
};
BlockSubtitle.propTypes = {
  children: _propTypes["default"].node.isRequired,
  id: _propTypes["default"].string,
  /**
   * The css classes for the block subtitle
   */
  className: _propTypes["default"].string
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(BlockSubtitle);